<template>
  <div class="col d-flex tab-bisiness-product">
    <!-- <span class="icon-right product-icon-right"></span> -->
    <a
      class="cat-pro"
      v-for="(val, index) in cats"
      :key="index"
      :class="{ active: selectedCatId == val.id }"
      @click.prevent="selectedCatId = val.id"
    >
      <p>{{ val.title }}</p>
    </a>
    <!-- <span class="icon-left product-icon-left"></span> -->
  </div>
</template>

<script>
export default {
  name: "Category",
  props: ["data"],

  data() {
    return {
      cats: [],
      selectedCatId: 0,
    };
  },

  watch: {
    data(val) {
      this.cats = val;
    },

    selectedCatId(val) {
      this.$emit("getCatId", val);
    },
  },
};
</script>